import React from "react";
import { getContentPageProps, getUniqueIdForContentTypeAlias } from "../../logic/contentLogic";

const FullscreenHeader = React.lazy(() => import("../../components/Magazine/modules/fullscreenHeaderContainer/FullscreenHeaderContainer.js"));

export const renderFullscreenHeader = (content, props = {}) => {
  return <FullscreenHeader key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)} content={content} {...getContentPageProps(content)} />;
};
